import React from "react";
import { useTranslation } from "react-i18next";
import TarjetaDeServicioPostulate from "./components/TarjetaDeServicioPostulate";
import "./Careers.css";
import CarruselPostulate from "./components/CarruselPostulate";
import FormularioPostulacion from "./components/FormularioPostulacion";
import SeccionExtra from "../services/components/SeccionExtra";
import IconosInformativos from "../../components/ui/IconosInformativos";
import { JobService } from "./types";

export default function Postulate() {
  const { t } = useTranslation();
  const services = t("pages.postulate.services", { returnObjects: true }) as JobService[];

  return (
    <div className="postulate-container">
      <main className="main-content">
        <CarruselPostulate />
        <h2 className="subtitle animate-up">{t("pages.postulate.subtitle")}</h2>
        <div className="card-grid">
          {Array.isArray(services) && services.map((s, i) => {
            let animationClass = "";
            if (i === 0) animationClass = "from-left";
            else if (i === 1) animationClass = "from-bottom";
            else if (i === 2) animationClass = "from-right";
            return (
              <TarjetaDeServicioPostulate
                key={s.title}
                service={s}
                animationClass={animationClass}
                delay={0}
              />
            );
          })}
        </div>
        <FormularioPostulacion />
        <SeccionExtra />
        <IconosInformativos />
      </main>
    </div>
  );
}
